import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import Header from "./Header";
import Table from "./Table/Table";
import CreateDocument from "./CreateDocument/CreateDocument";
import { ModalAccept } from "./Modals";
import { snackWrapper } from "helpers";
import { useLocation, useParams } from "react-router-dom";
import sass from "./DocumentTemplates.module.sass";
import { Button } from "../../../components/shared";
import { checkCompletingReferences } from "toolkit/references/references.thunks";
import { useAppDispatch } from "toolkit/hooks";
import { directoryAPI } from "libs/apiClient/Directory";
import { DocumentPatternResponse } from "libs/apiClient/data-contracts";
import { userAPI } from "libs/apiClient/User";

interface IModalState {
	mode: "remove" | "update";
	show: any;
	ok?: () => void;
}

const DocumentTemplate: FC = () => {
	const dispatch = useAppDispatch();

	const [documents, setDocuments] = useState<DocumentPatternResponse[]>([]);

	const [createDocument, setCreateDocument] = useState<boolean>(false);
	const [file, setFile] = useState<DocumentPatternResponse | null>(null);

	const [currentOrg, setCurrentOrg] = useState<number | null>(null);

	const location = useLocation();
	const urlParams = useParams();

	const getData = useCallback(() => {
		if (currentOrg !== null) {
			if (currentOrg > 0) {
				directoryAPI.docxTemplatesListDetail(currentOrg).then((data) => setDocuments(data.data));
			} else {
				directoryAPI.docxTemplatesListList().then((data) => setDocuments(data.data));
			}

			dispatch(checkCompletingReferences());
		}
		//eslint-disable-next-line
	}, [currentOrg]);

	useEffect(() => {
		getData();
		//eslint-disable-next-line
	}, [currentOrg]);

	const handleCreateDocument = (row: DocumentPatternResponse) => {
		setFile(row);
		setCreateDocument(true);
	};

	const getHelpDoc = () => {
		directoryAPI.docxTemplatesGetHelpList({ format: "blob" }).then((data) => {
			const filename = data.headers["content-disposition"]!.replace(/.+filename=(.+)$/g, "$1");
			const href = URL.createObjectURL(data.data as any);
			const link = document.createElement("a");
			link.href = href;
			link.download = filename;
			link.click();
			URL.revokeObjectURL(href);
			link.remove();
		});
	};

	const [modal, setModal] = useState<IModalState>({
		mode: "remove",
		show: false,
		ok: (cb?: () => void) => {
			cb && cb();
		},
	});

	const [isEdit, setIsEdit] = useState({
		read: false,
		edit: false,
		editItems: false,
	});
	useEffect(() => {
		// if (currentOrg !== null) {
		userAPI
			.permissionsCheckCreate(currentOrg || 0, [
				"dictionary.document_patterns.read",
				"dictionary.document_patterns.edit",
				"dictionary.user_document_patterns.edit",
			])
			.then(({ data }) =>
				setIsEdit({
					edit: data.includes("dictionary.document_patterns.edit"),
					read: data.includes("dictionary.document_patterns.read"),
					editItems: data.includes("dictionary.user_document_patterns.edit"),
				}),
			);
		// }
	}, [currentOrg]);

	const errorHandler = useMemo(() => {
		return {
			read: isEdit.read,
			edit: {
				active: isEdit.edit,
				snack() {
					snackWrapper("error", "Не достаточно прав");
				},
			},
			editItems: isEdit.editItems,
		};
	}, [isEdit]);

	const openConfirm = (cb: () => void, mode: "remove" | "update") => {
		setModal((prevState) => ({ ...prevState, mode, show: true, ok: cb }));
	};

	const closeModal = () => {
		setModal((prevState) => ({ ...prevState, show: false }));
	};

	useEffect(() => {
		setCurrentOrg(urlParams.org !== undefined ? Number(urlParams.org) : null);
		//eslint-disable-next-line
	}, [location.pathname]);

	const refForSelect = useRef<any>(null);

	return (
		<div className="step-wrapper">
			<ModalAccept mode={modal.mode} show={modal.show} close={closeModal} ok={modal.ok} />
			<Header error={errorHandler} getDoc={getHelpDoc} forward={refForSelect} />
			{currentOrg !== null ? (
				<Table
					error={errorHandler}
					openConfirm={openConfirm}
					getData={getData}
					documents={documents}
					handleCreateDocument={handleCreateDocument}
				/>
			) : (
				<div data-comment-false={true} className={sass.empty}>
					{/*<div className={sass.empty__content}>*/}
					Организация не выбрана
					<Button
						onMouseUp={(e) => {
							e.stopPropagation();
							e.preventDefault();
							refForSelect.current?.click();
						}}>
						Выбрать организацию
					</Button>
					{/*</div>*/}
				</div>
			)}
			{createDocument && (
				<CreateDocument getData={getData} close={() => setCreateDocument(false)} file={file} currentOrg={currentOrg} />
			)}
		</div>
	);
};

export default DocumentTemplate;
